import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { isUnauthorized, notifyUnauthorized } from "./session";

/**
 * The app QueryClient. A 401 on ANY query or mutation means the session was revoked/expired (R7):
 * signal the shell's SessionExpiryHandler, which clears the cache and routes to /login on the next
 * tick. Factored out of main so the revocation wiring is unit-testable.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1 },
    },
    queryCache: new QueryCache({
      onError: (error) => {
        if (isUnauthorized(error)) notifyUnauthorized();
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        if (isUnauthorized(error)) notifyUnauthorized();
      },
    }),
  });
}
